import './App.css';
import "./Style.css";
import Header from "./MyComponents/Header";
import Conference_Centre from "./MyComponents/Conference_Centre";
import Work_Cafes from "./MyComponents/Work_Cafes";
import Sustainability from "./MyComponents/Sustainability";
import Allergens from "./MyComponents/Allergens";
import Disclaimer from "./MyComponents/Disclaimer";
import Healthy_Recipes from "./MyComponents/Healthy_Recipes";
import Seasonal_Recipes from "./MyComponents/Seasonal_Recipes";
import Employee_Dinning from "./MyComponents/Employee_Dinning";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom"; 
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom"; 
import Footer from './MyComponents/Footer';
import CounterMenu from './MyComponents/CounterMenu';

function App() {
  return ( 
    <> 
      <Router>
        <Header />
        {/* Add Routes here */}
        <div className="page-container"> 
          <Routes>
            <Route path="/" element={<Employee_Dinning />} />
            <Route path="/conference-menu" element={<Conference_Centre />} />
            <Route path="/work-cafes" element={<Work_Cafes />} />
            <Route path="/sustainability" element={<Sustainability />} />
            <Route path="/allergens" element={<Allergens />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/healthy-recipes" element={<Healthy_Recipes />} />
            <Route path="/seasonal-recipes" element={<Seasonal_Recipes />} />
            <Route path="/employee-dinning" element={<Employee_Dinning />} />
            <Route path="/CounterMenu/:id" element={<CounterMenu />} />
          </Routes>
        </div>
        <Footer />
      </Router>
    </>
  );
}

export default App;
